import { TABS_TOOLS } from '../components/tools/tools.constants';
import {
  ANNOTATE_DRAW_TOOL_IDS,
  POINTER_ICONS,
  TABS_IDS,
} from '../utils/constants';

export const SELECT_TAB = 'SELECT_TAB';

const getPointerForTab = (tabId, toolId) => {
  if (tabId === TABS_IDS.ANNOTATE) {
    return toolId && ANNOTATE_DRAW_TOOL_IDS.includes(toolId)
      ? POINTER_ICONS.DRAW
      : POINTER_ICONS.DEFAULT;
  }
  return POINTER_ICONS.DEFAULT;
};

const selectTab = (state, payload) => {
  const nextTabId = payload.tabId ?? null;

  if (nextTabId == null || nextTabId === '') {
    if (state.tabId == null) {
      return state;
    }

    return {
      ...state,
      tabId: null,
      toolId: null,
      selectionsIds: payload.keepSelections ? state.selectionsIds : [],
      pointerCssIcon: POINTER_ICONS.DEFAULT,
    };
  }

  const tabTools = TABS_TOOLS[nextTabId] || [];
  const requestedToolId = payload.toolId;
  const nextToolId =
    requestedToolId && tabTools.includes(requestedToolId)
      ? requestedToolId
      : nextTabId === TABS_IDS.ANNOTATE
        ? null
        : tabTools[0] ?? null;

  if (nextTabId === state.tabId && state.toolId === nextToolId) {
    return state;
  }

  return {
    ...state,
    tabId: nextTabId,
    toolId: nextToolId,
    selectionsIds: payload.keepSelections ? state.selectionsIds : [],
    pointerCssIcon: getPointerForTab(nextTabId, nextToolId),
  };
};

export default selectTab;
